export class AuthorityMismatch extends Error {
  constructor(message = 'account authority does not match expected authority') {
    super(message);
    Object.setPrototypeOf(this, AuthorityMismatch.prototype);
  }
}

export class InvalidKeypairProvided extends Error {
  constructor(keypairPath: string) {
    super(`failed to load keypair resource ${keypairPath}`);
    Object.setPrototypeOf(this, InvalidKeypairProvided.prototype);
  }
}

export class InvalidKeypairFsPathProvided extends Error {
  constructor(keypairPath: string) {
    super(`no file found at ${keypairPath}`);
    Object.setPrototypeOf(this, InvalidKeypairFsPathProvided.prototype);
  }
}
